export const ORDERS_API_WINDOW_KEY = 'api' as const;
export const ORDERS_API_READY_EVENT = 'salja:orders:api-ready' as const;
